import styles from './style.module.scss';
import { ActionModal, Button, PageHeader } from 'components';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Route, Routes, useLocation } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useCandidatesAuto from '../useCandidatesAuto';
import UIHelper from '../../../../../helpers/UIHelper';
import { useNavigate } from '../../../../../hooks/useNavigate';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    handleDownloadExcel,
    updateInProcess,
    loading,
    onChangeTableFilter,
    onDelete,
  } = useCandidatesAuto();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <>
      <PageHeader title={t('CANDIDATURE SPONTANEE').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              loading={updateInProcess}
              onClick={handleDownloadExcel}
              icon={<ExcelIcon fill={'#fff'} />}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.candidates}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
          scroll={{ x: 3000 }}
          // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/view'}
          element={
            <ActionModal
              loading={loading}
              title={t(
                'Cliccando su continua verra’ salvato il log dell’operazione',
              )}
              description={''}
              type={'view'}
              yesBtnText={t('Continua')}
              noBtnText={t('Annulla')}
              onClickOk={() => navigate(UIHelper.getListRoute(pathname, 1))}
              onCancel={() => navigate(UIHelper.getListRoute(pathname, 2))}
            />
          }
        />
      </Routes>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
